import type { Component, Entity2D } from '../../odie';

import type { HalfIceBlockProps } from '../defs/block';
import { HalfIceBlockView } from '../views/blocks/HalfIceBlockView';

// types
//-----------------------------------------------------------------------------
export type HalfIceBlockComponentOptions = {
  props: HalfIceBlockProps;
};

/*
    half ice block component
*/
export class HalfIceBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockHalfIce';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: HalfIceBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: HalfIceBlockComponentOptions): void {
    // create half ice block view
    this.view = new HalfIceBlockView(options.props);
  }
}
